import { PassportFieldName } from "models/documents/international-passport";

export const elementIdFromPassportFieldName = (
  fieldName: PassportFieldName
): string => {
  return `passport-field-${fieldName}`;
};

export const passportFieldNameFromElementId = (
  elementId: string
): PassportFieldName => {
  const fieldName = elementId.replace("passport-field-", "");
  return fieldName as PassportFieldName;
};
